module.exports = __webpack_public_path__ + "img/4.2faf83b9.jpg";